import {
  BATTERY_PRESERVATION_TIMINGS,
  buildInstallationCronExpression,
  DEFAULT_PRODUCTION_TIMINGS,
  getTimingsSave,
  INSTALLATION_MODE_INTERVAL_MINUTES,
  isBatteryPreservationCronTimings,
  isInstallationCronTimings,
  normalizeTimings,
} from "./installationConfigUtils";

export const SCHEDULE_MODE_PRODUCTION = "production";
export const SCHEDULE_MODE_INSTALLATION = "installation";
export const SCHEDULE_MODE_BATTERY = "battery";

function detectScheduleMode(activeTimings) {
  if (isInstallationCronTimings(activeTimings)) {
    return SCHEDULE_MODE_INSTALLATION;
  }
  if (isBatteryPreservationCronTimings(activeTimings)) {
    return SCHEDULE_MODE_BATTERY;
  }
  return SCHEDULE_MODE_PRODUCTION;
}

function isSpecialScheduleTimings(timings) {
  return (
    isInstallationCronTimings(timings) ||
    isBatteryPreservationCronTimings(timings)
  );
}

function resolveProductionTimingsSave(configData, activeTimings, scheduleMode) {
  let timingsSave = getTimingsSave(configData);
  if (timingsSave?.length && isSpecialScheduleTimings(timingsSave)) {
    timingsSave = null;
  }

  if (!timingsSave?.length) {
    if (scheduleMode === SCHEDULE_MODE_PRODUCTION && activeTimings.length > 0) {
      return [...activeTimings];
    }
    return [...DEFAULT_PRODUCTION_TIMINGS];
  }

  return [...timingsSave];
}

function buildActiveTimingsForScheduleMode(
  scheduleMode,
  intervalMinutes,
  productionTimings,
) {
  if (scheduleMode === SCHEDULE_MODE_INSTALLATION) {
    return [buildInstallationCronExpression(intervalMinutes)];
  }
  if (scheduleMode === SCHEDULE_MODE_BATTERY) {
    return [...BATTERY_PRESERVATION_TIMINGS];
  }
  return productionTimings?.length
    ? [...productionTimings]
    : [...DEFAULT_PRODUCTION_TIMINGS];
}

function getProductionTimingsFromState(cronState) {
  if (cronState.scheduleMode === SCHEDULE_MODE_PRODUCTION) {
    return cronState.activeTimings?.length
      ? [...cronState.activeTimings]
      : [...cronState.timingsSave];
  }
  return [...cronState.timingsSave];
}

export function buildInitialCronState(configData) {
  const activeTimings = normalizeTimings(configData);
  const scheduleMode = detectScheduleMode(activeTimings);
  const timingsSave = resolveProductionTimingsSave(
    configData,
    activeTimings,
    scheduleMode,
  );

  return {
    scheduleMode,
    intervalMinutes: INSTALLATION_MODE_INTERVAL_MINUTES,
    activeTimings: buildActiveTimingsForScheduleMode(
      scheduleMode,
      INSTALLATION_MODE_INTERVAL_MINUTES,
      timingsSave,
    ),
    timingsSave,
  };
}

export function buildCronStateForScheduleMode(cronState, scheduleMode) {
  const productionTimings = getProductionTimingsFromState(cronState);

  return {
    ...cronState,
    scheduleMode,
    timingsSave: productionTimings,
    activeTimings: buildActiveTimingsForScheduleMode(
      scheduleMode,
      cronState.intervalMinutes ?? INSTALLATION_MODE_INTERVAL_MINUTES,
      productionTimings,
    ),
  };
}

export function resolveActiveTimingsForSave(cronState) {
  return buildActiveTimingsForScheduleMode(
    cronState.scheduleMode,
    cronState.intervalMinutes ?? INSTALLATION_MODE_INTERVAL_MINUTES,
    cronState.timingsSave,
  );
}
